export default "__VITE_ASSET__CnFqvrQv__"